/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Highsetpointtemperature2Inputs */



/**
* | output |
* | --- |
* | "High setpoint temperature" |
*
* @param {Br_History_Key_Highsetpointtemperature2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_highsetpointtemperature2 = /** @type {((inputs?: Br_History_Key_Highsetpointtemperature2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Highsetpointtemperature2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("High setpoint temperature")
	return /** @type {LocalizedString} */ ("Température de consigne haute")
});
export { br_history_key_highsetpointtemperature2 as "br_history_key_highSetpointTemperature" }